.radioCardButton:global(.MuiButton-root) {
	border-radius: inherit;

	&:focus-visible {
		outline: none;
		outline-offset: 0;
	}

	&:hover {
		background-color: transparent !important;
	}
}

.radioCardContainer {
	border-radius: 12px;

	&.selected {
		border: 1px solid #975ede;
		background: #fefdff;

		&:hover {
			background-color: #faf6ff;
		}
	}

	&.notSelected {
		border: 1px solid #e2e2e2;
		background-color: #fff;

		&:hover {
			background-color: #f4f4f4;

			& .radioIconContainer {
				background-color: #ececec;
			}
		}
	}

	&.disabled {
		opacity: 0.7;
		background-color: #f8f8f8;

		& .radioCardButton {
			cursor: not-allowed;
			pointer-events: auto;
		}
	}

	&:has(.radioCardButton:focus-visible) {
		border: 1px solid var(--focus-outline-color-dark);
	}

	&:has(.secondaryActionWrapper:hover) {
		background-color: #fff;
	}
}

.selectIconWrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	border-radius: 50%;
	border: 2px solid transparent;

	&.notSelected {
		background-color: #fff;
		border-color: #d1d5dc;
	}

	&.selected {
		background-color: #874bd3;
		border: none;
	}

	&.hidden {
		opacity: 0;
		pointer-events: none;
	}

	& svg {
		color: #fff;
	}
}

.radioIconContainer {
	display: flex;
	position: relative;
	border-radius: 11.67px;
	align-items: center;
	justify-content: center;
	background-color: #f3f4f6;
	flex-shrink: 0;

	& svg {
		color: #898989;
		width: 20px;
		height: 20px;
	}

	&.enabled {
		background-color: #f4ebff;
	}

	&.enabled svg {
		color: #874bd3;
	}

	& .greenCheck {
		position: absolute;
		bottom: -6px;
		right: -6px;
		z-index: 2;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		border: 2px solid #ffffff;
		background-color: #0b6f85;
		display: flex;
		align-items: center;
		justify-content: center;

		& svg {
			color: #fff;
			width: 12px;
			height: 12px;
		}
	}
}
